"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));

require("react-day-picker/lib/style.css");

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _moment = require("react-day-picker/moment");

var _Box = _interopRequireDefault(require("../Box"));

var _Input = _interopRequireDefault(require("../Input"));

var _boxprops3 = _interopRequireDefault(require("../../util/boxprops"));

var _moment2 = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Wrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "DateInput__Wrapper",
  componentId: "w95ixs-0"
})(["position:relative;svg{cursor:pointer;color:", ";}"], (0, _themeGet["default"])('colors.neutral.300'));

var _StyledWrapper = (0, _styledComponents["default"])(Wrapper).withConfig({
  displayName: "DateInput___StyledWrapper",
  componentId: "w95ixs-1"
})(["position:relative;"]);

var DefaultIcon = function DefaultIcon(props) {
  return _react["default"].createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "calendar-alt",
    className: "svg-inline--fa fa-calendar-alt fa-w-14 calendar-icon",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
  }));
};

var InputComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputComponent, _React$Component);

  function InputComponent(props) {
    var _this;

    _classCallCheck(this, InputComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputComponent).call(this, props));
    _this.inputRef = _react["default"].createRef();
    return _this;
  }

  _createClass(InputComponent, [{
    key: "focus",
    value: function focus() {
      this.inputRef.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          boxProps = _this$props.boxProps,
          onIconClick = _this$props.onIconClick,
          props = _objectWithoutProperties(_this$props, ["boxProps", "onIconClick"]);

      return _react["default"].createElement(_StyledWrapper, boxProps, _react["default"].createElement(_Input["default"], _extends({
        ref: this.inputRef,
        pr: 4,
        width: boxProps.width
      }, props)), _react["default"].createElement(DefaultIcon, {
        style: {
          position: 'absolute',
          right: '8px',
          top: '10px'
        },
        onClick: onIconClick
      }));
    }
  }]);

  return InputComponent;
}(_react["default"].Component);

var DateInput =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(DateInput, _React$Component2);

  function DateInput(props) {
    var _this2;

    _classCallCheck(this, DateInput);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(DateInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      /** Needed to force rerender DateInput and clear its input */
      renderKey: 0,

      /** Managing the value in state allows us to change it as needed */
      internalValue: undefined
    });

    _defineProperty(_assertThisInitialized(_this2), "onDayChange", function (day) {
      _this2.props.onChange({
        target: {
          value: day
        }
      }, day);

      _this2.setState({
        internalValue: day
      });

      _this2.hasValue = !!day;
    });

    _defineProperty(_assertThisInitialized(_this2), "onIconClick", function () {
      return _this2.dayPickerRef.current.getInput().focus();
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      _this2.setState({
        internalValue: _this2.props.value
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidUpdate", function (prevProps) {
      // Update internal value whenever value from props change.
      var hasValueFromPropsChanged = prevProps.value !== _this2.props.value;
      if (hasValueFromPropsChanged) _this2.setState({
        internalValue: _this2.props.value
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "onBlur", function () {
      var inputObj = _this2.dayPickerRef && _this2.dayPickerRef.current && _this2.dayPickerRef.current.getInput && _this2.dayPickerRef.current.getInput();

      var input = inputObj && inputObj.inputRef && inputObj.inputRef.current;
      if (!input) return; // If we have input that is not parsed by default parse but is parsed by moment,
      // let's assume that input is meant to be what moment produced

      var valueToApply = !_this2.hasValue && (ensureDate(input.value) || ensureDate(_this2.props.value));

      if (valueToApply) {
        _this2.setState({
          internalValue: valueToApply
        });

        _this2.props.onChange({
          target: {
            value: valueToApply
          }
        }, valueToApply);

        _this2.hasValue = true;
      }

      var hasInvalidInputValue = !_this2.hasValue && input.value;

      if (hasInvalidInputValue) {
        // DayPickerInput doesn't provide a way to clear values, so we will start new instance instead
        // by incrementing the render key
        _this2.setState(function (_ref) {
          var renderKey = _ref.renderKey;
          return {
            renderKey: renderKey + 1
          };
        });
      }
    });

    _this2.dayPickerRef = _react["default"].createRef();
    return _this2;
  }

  _createClass(DateInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format,
          value = _this$props2.value,
          props = _objectWithoutProperties(_this$props2, ["onChange", "format", "value"]);

      var _boxprops = (0, _boxprops3["default"])(props),
          _boxprops2 = _slicedToArray(_boxprops, 2),
          boxProps = _boxprops2[0],
          rest = _boxprops2[1];

      return _react["default"].createElement(_DayPickerInput["default"], _extends({
        key: this.state.renderKey,
        ref: this.dayPickerRef,
        keepFocus: true,
        onDayChange: this.onDayChange,
        formatDate: _moment.formatDate,
        format: format,
        parseDate: _moment.parseDate,
        component: InputComponent,
        inputProps: {
          onIconClick: this.onIconClick,
          placeholder: rest.placeholder || 'mm/dd/yyyy',
          onBlur: this.onBlur,
          boxProps: boxProps
        },
        value: ensureDate(this.state.internalValue)
      }, rest));
    }
  }]);

  return DateInput;
}(_react["default"].Component);

_defineProperty(DateInput, "defaultProps", {
  format: 'MM/DD/YYYY',
  placeholder: '',
  onChange: function onChange() {},
  icon: DefaultIcon
});

var _default = DateInput;
exports["default"] = _default;

var ensureDate = function ensureDate(rawValue) {
  var momentValue = rawValue && (0, _moment2["default"])(rawValue);
  var value = momentValue && momentValue.isValid() ? momentValue.toDate() : undefined;
  return value;
};